import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import Portfolio from './pages/Portfolio';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));

// Simple routing based on path
const renderApp = () => {
  const path = window.location.pathname;
  
  if (path === '/portfolio') {
    return <Portfolio />;
  }
  
  return <App />;
};

root.render(
  <React.StrictMode>
    {renderApp()}
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
